import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { useEndpoints } from "../../api/ApiContext";
import { useSession } from "../../auth/AuthProvider";
import { Banner, ButtonLink, Card, PageHeader, SkeletonBlock, StatusPill } from "../../components/ui";

export function PublisherOverview() {
  const ep = useEndpoints();
  const session = useSession();
  const connect = useQuery({ queryKey: ["connect-status"], queryFn: () => ep.publisher.getConnectAccountStatus() });

  return (
    <div className="stack-lg">
      <PageHeader
        title="Overview"
        description="Register your MCP server, integrate the SDK, and get paid."
        actions={<ButtonLink to="/publisher/sites/new" variant="primary">Add site</ButtonLink>}
      />
      {session.mfa === "not_enrolled" ? (
        <Banner tone="warning" title="Set up two-step verification">
          Payout setup and payouts are locked until you do. <Link to="/publisher/security?setup=1">Set it up now</Link>.
        </Banner>
      ) : null}
      <Card title="Payouts">
        {connect.isPending ? (
          <SkeletonBlock lines={2} />
        ) : connect.data?.payouts_enabled ? (
          <div className="row">
            <StatusPill tone="success">Payouts enabled</StatusPill>
            <Link to="/publisher/payouts">Request a payout</Link>
          </div>
        ) : (
          <div className="stack-sm">
            <StatusPill tone="warning">{connect.data?.linked ? "Payout setup incomplete" : "Payout setup not started"}</StatusPill>
            <p className="small">
              You can add sites and serve traffic now; earnings accrue and are paid once payout setup and identity verification are done.
            </p>
            <div>
              <ButtonLink to="/publisher/payout-setup" size="sm">
                Payout setup
              </ButtonLink>
            </div>
          </div>
        )}
      </Card>
      <Card title="Get started">
        <ol className="stack-sm" style={{ margin: 0, paddingLeft: "1.25rem" }}>
          <li>
            <Link to="/publisher/security">Turn on two-step verification</Link>.
          </li>
          <li>
            <Link to="/publisher/sites/new">Add your site</Link> and publish the DNS record to prove you control the domain.
          </li>
          <li>Add a slot for each MCP tool that can carry an ad, then create an API key.</li>
          <li>Integrate the SDK: decorate tool results and add the post-send hook.</li>
          <li>
            <Link to="/publisher/payout-setup">Set up payouts</Link>.
          </li>
        </ol>
      </Card>
    </div>
  );
}
